import { render, staticRenderFns } from "./mp4.vue?vue&type=template&id=0276e4fa&scoped=true"
import script from "./mp4.vue?vue&type=script&lang=js"
export * from "./mp4.vue?vue&type=script&lang=js"
import style0 from "./mp4.vue?vue&type=style&index=0&id=0276e4fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0276e4fa",
  null
  
)

export default component.exports